import { OutreachAttempt } from "@coherehealth/core-platform-api";
import { OutreachAttempt as QmOutreachAttempt } from "@coherehealth/qm-api";

/**
 * Groups core-platform OutreachAttempts by serviceRequestId and maps each to the QM
 * OutreachAttempt shape. Normalizes `status=FAILED` to `outreachOutcome=FAILED` for
 * automated attempts (OutreachAttemptJob sets `status` but never `outreachOutcome`;
 * the chip logic checks `outreachOutcome`).
 *
 * Filters to MISSING_INFO_CLINICAL only — mirrors the server-side filter in
 * qm-servicerequest-consumer's ServiceRequestFilterService:250 that builds the
 * original embedded snapshot. Without this, non-MI attempts (NUDGES, SCHEDULING_OUTREACH)
 * could trigger a false "Automation Failed" chip.
 */
export function buildAttemptsBySr(freshAttempts: OutreachAttempt[]): Record<string, QmOutreachAttempt[]> {
  const attemptsBySr: Record<string, QmOutreachAttempt[]> = {};

  freshAttempts.forEach((attempt) => {
    const srId = attempt.serviceRequestId;
    if (srId && attempt.outreachType === "MISSING_INFO_CLINICAL") {
      if (!attemptsBySr[srId]) {
        attemptsBySr[srId] = [];
      }
      attemptsBySr[srId].push({
        outreachAttemptId: attempt.id,
        dateCreated: attempt.scheduledSend,
        outreachOutcome: attempt.outreachOutcome || (attempt.status === "FAILED" ? "FAILED" : undefined),
        manual: attempt.manual,
        attemptNumber: attempt.attemptNumber,
      });
    }
  });

  return attemptsBySr;
}
